import copy from 'copy-to-clipboard';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import BannerImg from '../../../../public/assets/images/BannersFiles/20.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import CircularProgress from '@mui/material/CircularProgress';
const Zakat = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [isLoading, setIsLoading] = useState(false);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [epUserID, setEpUserID] = useState(null);
  const token = localStorage.getItem('token');
  const [formValues, setFormValues] = useState({
    amount: '',
    name: '',
    mobile: '',
    email: '',
    countryId: '208',
    emirates: '3',
  });
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);
  useEffect(() => {
    localStorage.setItem('isHome', true);
    getEmirates();
    getCountries();
    getProjectData();
  }, []);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const errors = {};
    if (!formValues.amount) errors.amount = 'Amount is required';
    if (formValues.amount && formValues.amount <= 0) errors.amount = 'amount must be greater than or equal to 0 ';
    if (!formValues.name) errors.name = 'Full Name is required';
    if (!formValues.mobile) errors.mobile = 'Mobile is required';
    if (!formValues.email) errors.email = 'Email Address is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const getProjectData = async () => {
    await getAsync('APIClient/Zakat')
      .then((response) => {
        const result = response?.data;
        setApiData(result);
        if (response?.statusCode == 204) {
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true); 
      const data = {
        moduleID: '5',
        projectID: apiData?.zakatID,
        amount: formValues.amount,
        moduleName: 'Zakat',
        projectName: apiData?.ayathNo,
        projectNameByDonor: apiData?.ayathNo,
        donorNameByDonor: formValues?.name,
        donorProjectName: apiData?.ayathNo,
        userID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        comments: '',
        firstName: formValues?.name,
        lastName: formValues?.name,
        emirate: formValues?.countryId ? formValues?.emirates : '',
        mobile: formValues?.mobile,
        email: formValues?.email,
        isGift: false,
        giftedPersonName: '',
        giftedPersonNumber: '',
        giftedPersonEmail: '',
        countryId: formValues?.countryId,
        cityId: 0,
        recuringType: '1',
        isFromCart: false,
        middleName: '',
        giftType: 0,
        sponsorshipNoOfYears: 0,
        isRecurring: true,
        recurringTenure: 0,
        afterPaymentReturnPath: '',
        userIdNumber: 0,
        processID: '6',
        refferalLink: apiData?.zakatID,
        registerUserID: epUserID !== null ? epUserID : 0,
      };

      try {
        const response = await postAsync(`APIClient/PaymentRequestZakat`, data);

        if (response.statusCode === 200) {
          localStorage.setItem('isPayment', true);
          window.location.href = response?.paymentPortal;
        } else {
          toast.error('Something went wrong, Please try again!');
        }
      } catch (err) {
        toast.error('Something went wrong, Please try again!');
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (validateForm()) {
  //     setIsLoading(true); // Start loading
  //     const data = {
  //       moduleID: '5',
  //       projectID: apiData?.zakatID,
  //       amount: formValues.amount,
  //       moduleName: 'Zakat',
  //       projectName: apiData?.ayathNo,
  //       projectNameByDonor: apiData?.ayathNo,
  //       donorNameByDonor: formValues?.name,
  //       donorProjectName: apiData?.ayathNo,
  //       userID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  //       comments: '',
  //       firstName: formValues?.name,
  //       lastName: formValues?.name,
  //       emirate: formValues?.countryId ? formValues?.emirates : '',
  //       mobile: formValues?.mobile,
  //       email: formValues?.email,
  //       isGift: false,
  //       giftedPersonName: '',
  //       giftedPersonNumber: '',
  //       giftedPersonEmail: '',
  //       countryId: formValues?.countryId,
  //       cityId: 0,
  //       recuringType: '1',
  //       isFromCart: false,
  //       middleName: '',
  //       giftType: 0,
  //       sponsorshipNoOfYears: 0,
  //       isRecurring: true,
  //       recurringTenure: 0,
  //       afterPaymentReturnPath: '',
  //       userIdNumber: 0,
  //       processID: '6',
  //       refferalLink: apiData?.zakatID,
  //       registerUserID: epUserID !== null ? epUserID : 0,
  //     };

  //     try {
  //       const response = await postAsync(`APIClient/PaymentRequestZakat`, data);
  //       if (response.statusCode === 200) {
  //         localStorage.setItem('isPayment', true);
  //         window.location.href = response?.paymentPortal;
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  // };
  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList')
      .then((response) => {
        const result = response?.data;
        setCountryData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getUserData = async () => {
    console.log('setFormValuessetFormValues');
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        console.log(result, 'resultresult');

        if (result) {
          setFormValues((prevState) => ({
            ...prevState,
            name: result?.fullName || '',
            email: result?.email || '',
            phone: result?.mobile || '',
          }));
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    //getppProjectData();

    if (token) {
      if (epUserID !== null) {
        getUserData();
        PageHitCountApi(location.pathname, epUserID);
      }
      localStorage.setItem('isHome', false);
    } else {
      PageHitCountApi(location.pathname, 0);
      localStorage.setItem('isHome', true);
    }
  }, [epUserID]);

  const handleCopy = () => {
    if (pid != 7) {
      const campaignRefferalLink = `${reactURL}/PaymentProcess/` + refferalLink + '/' + refferalLink + '/' + pid;
      copy(campaignRefferalLink);
      toast.success(t('Link copy Successfully'));
    } else {
      const campaignRefferalLink = `${reactURL}/PaymentProcess/` + id + '/' + id + '/' + pid;
      copy(campaignRefferalLink);
      toast.success(t('Link copy Successfully'));
    }
  };
  return (
    <>
      <div className=" ">
        <StaticBanner BannerImg={BannerImg} en_US={'Zakat Money'} arabic={false} />
        <section
          className={`sm:h-90 flex
          flex-col lg:flex-row gap-10  px-5 lg:px-20   py-10 ${isActive ? 'text-left' : 'text-right'}`}
        >
          <img src={'/assets/images/zakat.jpg'} className=" lg:max-w-screen-sm " />

          <div className="w-full  flex flex-col justify-center items-center    lg:w-3/4 mt-4 ">
            <h4 className={`text-customgreen flex sm:text-2xl items-center leading-10 text-justify `}>
              {isActive
                ? `المال إذا بلغ النصاب وحال عليه الحول وكانت ملكيته كاملة , وجبت زكاته على مالكه, وفيه ربع العشر ( 2.5% )
            ولمعرفة الواجب الزكوي , في حالة اختيار الحول الهجري : إما نضرب المبلغ بـ (2.5%) أو نقسمه على 40 وفي الحالتين
            النتيجة واحدة . في حالة اختيار الحول الميلادي : نضرب المبلغ بـ (2.577%)`
                : `When wealth reaches the nisab (minimum amount) and a lunar year passes while it is in full ownership, its Zakat is obligatory. The amount due is 2.5%. To calculate Zakat for the lunar year, multiply the amount by 2.5% or divide it by 40. For the solar year, multiply by 2.577%.
`}
            </h4>
            <br />
            <h4 className={`text-customgreen  flex sm:text-2xl items-center leading-10 text-justify pt-1 `}>
              {isActive
                ? `  الزكاة كما لا يخفى، لا بد لأن تكون في موضع القبول أن تصرف في مصارفها الشرعية، والتي حددها الله عزو جل في قوله:
          [ إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ قُلُوبُهُمْ
          وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ فَرِيضَةً مِنَ اللَّهِ وَاللَّهُ
          عَلِيمٌ حَكِيمٌ] [التوبة:60]، فهؤلاء المذكورون في هذه الآية الكريمة هم أهل الزكاة الذين جعلهم الله محلاً
          لدفعها إليهم, لا يجوز صرف شيء منها إلى غيرهم إجماعاً.`
                : `Recipients of Zakat
                Zakat must be spent on its rightful recipients as outlined by Allah in the Quran: {Indeed, Zakat expenditures are only for the poor and for the needy and for those employed to collect [Zakat] and for bringing hearts together [for Islam] and for freeing captives [or slaves] and for those in debt and for the cause of Allah and for the [stranded] traveler - an obligation [imposed] by Allah. And Allah is Knowing and Wise} [At-Tawbah: 60]. It is unanimously agreed that Zakat should not be spent on other charitable projects like building mosques and schools, as indicated by the verse specifying its recipients.`}

              {isActive
                ? `  ولا يجوز صرف الزكاة في غير هذه المصارف التي عينها الله من المشاريع الخيرية الأخرى, كبناء المساجد والمدارس,
          لقوله تعالى: [ إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ] الآية, و (إنما) تفيد الحصر, وتثبت الحكم
          لما بعدها, وتنفيه عما سواه, والمعنى: ليست الصدقات لغير هؤلاء, بل لهؤلاء خاصة, وإنما سمى الله الأصناف الثمانية,
          إعلاماً منه أن الصدقة لا تخرج من هذه الأصناف إلى غيرها.`
                : ``}
            </h4>
          </div>
        </section>

        <div className="mx-5 lg:mx-20">
          <div className="w-full my-10 mx-auto border flex  justify-center items-center bg-green-50 rounded-xl py-10 lg:w-3/4 px-4 ">
            <form className="w-full space-y-6">
              <div>
                <label>{t('Zakat on money')}</label>
                <input
                  placeholder={t('Amount')}
                  type="text"
                  id="amount"
                  className="items-left w-full px-4 py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                  name="amount"
                  maxLength="7"
                  value={formValues.amount}
                  onInput={(event) => {
                    const { value } = event.target;
                    const regex = /^\d*(\.\d{0,2})?$/;

                    if (regex.test(value)) {
                      setFormValues((prev) => ({ ...prev, amount: value }));
                    } else {
                      event.target.value = value.slice(0, -1);  
                    }
                  }}
                />
                {formErrors.amount && <p className="text-red-700">{t(formErrors.amount)}</p>}
              </div>

              <div>
                <label>{t('Donor Name')}</label>
                <input
                  placeholder={t('Donor Name')}
                  type="text"
                  id="donorName"
                  className="items-left  w-full px-4 py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                  name="name"
                  value={formValues.name}
                  onChange={(e) => handleChange(e)}
                />
                {formErrors.name && <p className="text-red-700">{t(formErrors.name)}</p>}
              </div>
              {formValues?.countryId == 208 && (
                <>
                  <div>
                    <label>{t('Emirates')}</label>

                    <select
                      id="emirates"
                      className="w-full px-4   items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                      name="emirates"
                      value={formValues.emirates}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value={''}>--{t('SELECT EMIRATES')}--</option>
                      {emiratesAPIData?.map((item) => {
                        return (
                          <option key={item.emiratesID} value={item.emiratesID}>
                            {t(isActive ? item?.ar_SA : item?.en_US)}
                          </option>
                        );
                      })}
                    </select>
                    {formErrors.emirates && <p className="text-red-700">{t(formErrors.emirates)}</p>}
                  </div>
                </>
              )}

              <div>
                <label>{t('Select Country')}</label>
                <select
                  disabled="true"
                  id="country"
                  className="w-full px-4 items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                  name="countryId"
                  value={formValues.countryId}
                  onChange={(e) => handleChange(e)}
                >
                  {countryData?.map((item) => (
                    <option key={item.countryID} value={item.countryID}>
                      {isActive ? item?.ar_SA : item.countryName}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label>{t('Mobile')}</label>
                <input
                  placeholder={t('Your mobile number should starts with +971.')}
                  type="text"
                  maxLength={13}
                  id="phoneNumber"
                  className="w-full px-4  py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                  name="mobile"
                  value={formValues?.phone}
                  onChange={(e) => handleChange(e)}
                  onInput={(event) => {
                    const { value } = event.target;
                    const regex = /^\d+(\.\d{0,2})?$/;

                    if (regex.test(value)) {
                    } else {
                      event.target.value = value.slice(0, -1);
                    }
                  }}
                />
                {formErrors.mobile && <p className="text-red-700">{t(formErrors.mobile)}</p>}
              </div>

              <div>
                <label>{t('Email')}</label>
                <input
                  placeholder={t('Email')}
                  type="email"
                  id="email"
                  className="w-full px-4  items-start py-2 border border-gray-300 focus:ring-customgreen hover:focus:border-customgreen rounded-md"
                  name="email"
                  value={formValues.email}
                  onChange={(e) => handleChange(e)}
                />
                {formErrors.email && <p className="text-red-700">{t(formErrors.email)}</p>}
              </div>

              <div className="flex gap-3 items-center justify-center">
                {isLoading ? (
                  <CircularProgress className="!text-customgreen" />
                ) : (
                  <>
                    <button className="" onClick={handleSubmit}>
                      <img src="/assets/images/cardPaymentDouble.png" alt="card pay double" />
                    </button>
                    <button className="" onClick={handleSubmit}>
                      <img src="/assets/images/applePay.png" alt="apple pay" />
                    </button>
                    <button className="" onClick={handleSubmit}>
                      <img src="/assets/images/samsungPay.png" alt="samsung pay" />
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Zakat;
